const routeToLearnApp: Record<string, boolean> = {
  admin: true,
  explore: false,
};

// Keep this in sync with AngularJS app.
const viewContentTypesToAngularPath: Record<string, string> = {
  article: "articles",
  assessment: "assessments",
  file: "files",
  "imported-content": "imported-content",
  imported_content: "imported-content",
  journey: "journey",
  "multi-session-workshop": "multi-session-workshops",
  multi_session_workshop: "multi-session-workshops",
  presentation: "presentations",
  scorm: "scorm",
  survey: "survey",
  track: "tracks",
  workshop: "workshops",
  video: "videos",
};

// Keep this in sync with AngularJS app.
const viewContentTypesToLearnerPath: Record<string, string> = {
  article: "article",
  assessment: "assessment",
  file: "file",
  "imported-content": "imported-content",
  imported_content: "imported-content",
  journey: "journey",
  "multi-session-workshop": "multi-session-workshop",
  multi_session_workshop: "multi-session-workshop",
  presentation: "presentation",
  scorm: "scorm",
  survey: "survey",
  track: "track",
  workshop: "workshop",
  video: "video",
};

// When we need to configure in-app routing based on per-company attributes,
// call this from the company loader.
export const setupRouteLookupType = (typ: string, shouldRoute: boolean) => {
  routeToLearnApp[typ] = shouldRoute;
};

export const admin = () => {
  if (routeToLearnApp.admin) {
    return "/pvt/#/overview/admin";
  }
  return "/TODO/admin";
};

export const editContentType = (contentType: string, id: string) => {
  if (
    contentType === "article" ||
    contentType === "file" ||
    contentType === "video" ||
    contentType === "scorm" ||
    contentType === "journey" ||
    contentType === "assessment"
  ) {
    return `/admin/edit/${contentType}/${id}`;
  }

  if (contentType === "track") {
    return `/admin/edit/course/track/${id}`;
  }

  if (contentType === "imported_content") {
    return `/admin/edit/course/${id}`;
  }

  return `/pvt/#/edit/${viewContentTypesToAngularPath[contentType]}/${id}`;
};

export const hostContentType = (contentType: string, id: string) => {
  if (routeToLearnApp.admin) {
    return `/pvt/#/host/${viewContentTypesToAngularPath[contentType]}/${id}`;
  }
  return `/TODO/${viewContentTypesToLearnerPath[contentType]}/${id}`;
};

// Assessments are mid-migration, so the destination is a runtime decision on
// the assessmentsMigration flag rather than a static map entry. Callers still
// pick their own navigation primitive: the React path is an SPA route, the
// legacy one a hard nav into the /pvt shell.
export const assessmentAnalyticsPath = (id: string, migrated: boolean) => {
  if (migrated) {
    return `/admin/content/assessment/${id}/analytics`;
  }
  // hostContentType takes the singular form and maps it to the plural legacy
  // path segment itself (assessment -> assessments) — passing the
  // already-pluralized form would miss the lookup.
  return hostContentType("assessment", id);
};

